module.exports = __webpack_public_path__ + "static/media/Soleria-v2.f418df97.png";